const {bind} = require('./lib/bind')
const {Get} = require('./lib/ajax')

// Validate SlideShare URL
bind(document, 'DOMContentLoaded', function() {
  if(!document.getElementById('slideshare-import')) return

  const form = document.getElementById('slideshare-import')

  form.addEventListener("submit", function(event) {
    event.preventDefault()
    const input = document.getElementById('slideshare-url')
    const url = input.value

    // Validate the URL at /account/import/validate
    this.toggleRequest = new Get('/account/import/validate?url=' + url, {
      success: function(response) {
        if(!response){
          form.submit()
        } else {
          const notice = document.getElementById('slideshare-validation')
          notice.innerHTML = "URL validation failed with '" + response + "'. Please check the URL and try again."
          notice.style.display = 'block'

          // Re-enable the submit button
          const submit = document.getElementById('slideshare-submit')
          submit.disabled = false
          input.focus()
        }
      },
      error: function(response) {
        console.log('error', response)
        const notice = document.getElementById('slideshare-validation')
        notice.innerHTML = response.statusText
        notice.style.display = 'block'
      }
    })

  });
});

